<template>
  <div id="work-list-container" :style="shared.state.projectsLoading ? {'opacity': 0} : null">
    <div id="work-list">
      <work-list-entry v-for="entry in shared.state.projects"
                       :key="entry.sys.id"
                       :id="entry.sys.id"
                       :title="entry.fields.title"
                       :thumb="entry.fields.thumb"></work-list-entry>
      <div v-for="n in shared.state.projects.length" :key="'empty-'+ n" class="empty-cells"></div>
    </div>
    <a href="https://www.contentful.com/" rel="nofollow" target=“_blank”>
    <img src="https://images.contentful.com/fo9twyrwpveg/7Htleo27dKYua8gio8UEUy/0797152a2d2f8e41db49ecbf1ccffdaa/PoweredByContentful_DarkBackground_MonochromeLogo.svg" style="max-width: 100px;width: 100%;position: relative;left: 50%;transform: translateX(-50%);margin: 18px 0;" alt="Powered by Contentful" />
    </a>
  </div>
</template>
<script>
import store from '../store'
import workListEntry from './WorkListEntry'

export default {
  name: 'workList',
  components: {
    'work-list-entry': workListEntry
  },
  data () {
    return {
      shared: store
    }
  },
  created () {
    store.getProjects(this.$route.params.category)
  },
  watch: {
    '$route.params.category': (category) => {
      store.getProjects(category)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #work-list-container {
    width: 100%;
    margin: 0;
    padding: 0;
    opacity: 1;
    transition: opacity 0.2s;
  }

  #work-list {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    margin: 18px;
    padding: 0;
  }

  .empty-cells {
    content: '';
    margin: 0 9px;
    width: 360px;
    height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/WorkList.vue